























import { Vue, Component, Prop, Emit, Watch } from "vue-property-decorator";
import Modeler from "@/components/Modeler.vue";
import LightbendPlatform from "@/components/LightbendPlatform.vue";
import CustomApp from "@/components/CustomApp.vue";

@Component({
  components : {
    LightbendPlatform, Modeler, CustomApp
  }
})
export default class Technology extends Vue {
  
}
